import {View} from 'react-native';
import moment from 'moment';
import sy from '~/styles';
import {
  Text,
  Pressable,
  FormTextInput,
  FormNumberInput,
  Checkbox,
  CarPersona,
} from '~/components/controls';
import {Grouping} from '~/components/controls/3';
import {
  Row as GroupingRow,
  EditDialog as GroupingRowEdit,
} from '~/components/controls/3/Grouping';
import Format from '~/lib/format';
import {car as carApi} from '~/api/private';
const VehicleDetails = ({
  overview,
  car,
  vin_number,
  vin_part,
  editVin,
  setEditVin,
  onUpdateRequest,
  refresh,
  editKilometrage,
  setEditKilometrage,
  setCar,
  onUpdateCar,
}) => (
  <Grouping
    icon={<CarPersona size={24} brand={overview?.car_brand} />}
    header={overview?.car_name}>
    <GroupingRow
      title={
        <View style={[sy['flex-row'], sy['items-center']]}>
          <Text>Chassisnr. (VIN)</Text>
        </View>
      }
      onEditClicked={async () => {
        const {vin_number} = await carApi.vinLookup(overview.license, vin_part);

        setEditVin({
          vin_part,
          vin_number,
          valid: vin_number?.endsWith(vin_part),
        });
      }}>
      <Text>{vin_number?.length ? vin_number : <>Opgeven</>}</Text>
      <GroupingRowEdit
        title="Meldcode & VIN"
        dismissable
        cancelButton
        onValidate={() => {
          const valid =
            editVin.vin_part?.length === 4 &&
            editVin.vin_number?.endsWith(editVin.vin_part);

          setEditVin((prevState) => ({
            ...prevState,
            valid,
          }));
          return valid;
        }}
        onOK={async () => {
          if (editVin.valid) {
            await onUpdateRequest(editVin);
            refresh();
          }
        }}>
        <View style={[sy['p-4']]}>
          <FormTextInput
            label="Meldcode"
            value={editVin.vin_part}
            hasError={editVin?.valid === false}
            errorMessage="Meldcode is onjuist"
            onChangeText={(value) => {
              setEditVin((prevState) => ({
                ...prevState,
                vin_part: value,
                valid: true,
              }));

              if (value?.length === 4) {
                carApi
                  .vinLookup(overview.license, value)
                  .then(({vin_number}) => {
                    setEditVin((prevState) => ({
                      ...prevState,
                      vin_number: vin_number ?? prevState.vin_number,
                      valid: !!vin_number,
                    }));
                  });
              }
            }}
            inputProps={{
              maxLength: 4,
              keyboardType: 'numeric',
            }}
          />
        </View>
        <View style={[sy['p-4'], sy['pt-0']]}>
          <FormTextInput
            disabled
            label="Chassisnummer (VIN)"
            value={editVin.vin_number}
          />
        </View>
      </GroupingRowEdit>
    </GroupingRow>
    <GroupingRow title="Brandstof">
      <Text>{overview?.fuel}</Text>
    </GroupingRow>
    {car?.apk_expiry && (
      <GroupingRow title="APK vervaldatum">
        <Text>{moment(car?.apk_expiry).format('D-M-YYYY')}</Text>
      </GroupingRow>
    )}
    <GroupingRow
      title="Kilometerstand"
      onEditClicked={() => setEditKilometrage(overview?.mileage)}>
      <Text>{Format.number(overview?.mileage, 0, true) || <>Opgeven</>}</Text>
      <GroupingRowEdit
        title="Kilometerstand wijzigen"
        dismissable
        cancelButton
        onOK={() => {
          onUpdateRequest({mileage: editKilometrage});
        }}>
        <View style={[sy['p-4']]}>
          <FormNumberInput
            label="Kilometerstand"
            value={overview?.mileage}
            digits={0}
            onChangeNumber={setEditKilometrage}
          />
        </View>
      </GroupingRowEdit>
    </GroupingRow>
    {car?.entry_date && (
      <GroupingRow title="Eerste toelating">
        <Text>
          {moment(car?.entry_date).format('D-M-YYYY')}&nbsp;(
          {Format.number(
            moment().diff(moment(car?.entry_date), 'months') / 12,
            1,
            false,
            {minimumFractionDigits: 0},
          )}
          &nbsp;jaar)
        </Text>
      </GroupingRow>
    )}
    <GroupingRow title="Verzwaard gebruik">
      <Text>{car?.attributes?.heavy_use ? <>Ja</> : <>Nee</>}</Text>
      <GroupingRowEdit
        title={Format.license(car?.license)}
        initialValue={car}
        dismissable
        cancelButton
        onCancel={({initialValue}) => {
          setCar(initialValue);
          onUpdateCar(initialValue.attributes);
        }}>
        <Pressable
          style={[sy['p-4'], sy['gap-4'], sy['flex-row'], sy['items-center']]}
          onPress={() => {
            setCar((prevState) => {
              const attributes = {
                ...prevState.attributes,
                heavy_use: !prevState.attributes?.heavy_use,
              };

              onUpdateCar(attributes);

              return {
                ...prevState,
                attributes,
              };
            });
          }}>
          <Checkbox checked={car?.attributes?.heavy_use} />
          <Text>Verzwaard gebruik</Text>
        </Pressable>
      </GroupingRowEdit>
    </GroupingRow>
  </Grouping>
);
export default VehicleDetails;
